<template>
  <el-dialog
      :visible.sync="visible"
      :title="dialogTitle"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="凭证照片：" prop="imgs" style="margin-bottom: 0;">
            <MultipleImageUpload v-model="dataForm.imgs"></MultipleImageUpload>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="table-bar" style="margin:0;justify-content: flex-start;">
        <template v-if="$hasPermission('erp:purchase:checkin:batch')">
          <div class="bar-item">
            <UploadButton url="/erp/purchase/explain/checkin/old" @success="readFileSuccess"></UploadButton>
          </div>
          <FileLink file-type="front" file-url="/static/template/采购入库导入模板.xlsx" class="bar-item">下载模板
          </FileLink>
        </template>

      </div>
      <ImportErrorCard :errorList="errorList"></ImportErrorCard>
      <SweetTable :data="dataForm.detailList" :is-page="false" :height="500"
                  :summaries-column="['planCount','totalSendCount']">
        <el-table-column label="订单编号" prop="orderCode" align="center">
        </el-table-column>
        <el-table-column label="发货方" v-if="$hasPermission('erp:purchase:checkin:batch')" prop="senderName"
                         align="center" :show-overflow-tooltip="true" :formatter="$c.companyNameFormatter">
        </el-table-column>
        <el-table-column label="货品信息" prop="product.code" align="center">
          <template #default="{row }">
            <ProductRowCard :product="row.product"></ProductRowCard>
          </template>
        </el-table-column>
        <el-table-column label="计划数" prop="planCount" align="center" width="100">
        </el-table-column>
        <el-table-column label="已发货" prop="totalSendCount" align="center" width="100">
        </el-table-column>
        <el-table-column label="发货日期" prop="operateTime" align="center" width="160">
          <template v-slot="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.operateTime'"
                :rules="detailRule.operateTime"
                label-width="0"
            >
              <el-date-picker
                  v-model="scope.row.operateTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择时间"
                  size="mini"
                  style="width: 140px;" :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            v-if="sendType==='purchase'"
            label="发货单价"
            header-align="center"
            align="center"
            width="160"
        >
          <template v-slot="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.price'"
                :rules="detailRule.price"
                label-width="0"
            >
              <el-input v-model="scope.row.price" size="mini" @change="priceChange(scope.row)"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            v-for="r in receiverList"
            :key="r.id"
            :label="$c.companyName(r.name) "
            header-align="center"
            align="center"
            width="120"
        >
          <template v-slot="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.'+r.id"
                :rules="detailRule.count"
                label-width="0" v-if="scope.row[r.id]!=null&&scope.row[r.id]!=undefined" size="mini"
            >
              <el-input v-model="scope.row[r.id]"  @change="priceChange(scope.row)"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="金额"
            prop="totalAmount"
            header-align="center"
            align="center"
            width="140"
        >
        </el-table-column>
        <el-table-column
            label="备注"
            header-align="center"
            align="center"
        >
          <template v-slot="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.remark'"
                label-width="0"
                style="margin-bottom: 0px"
            >
              <el-input v-model="scope.row.remark" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button size="mini" @click="visible=false">{{ $t('cancel') }}</el-button>
      <el-button size="mini" type="primary" @click="dataFormSubmitHandle">确认发货</el-button>
    </template>
  </el-dialog>
</template>

<script>
/**
 * 供应商成品发货弹窗
 */
import UploadButton from '@/components/UploadButton.vue'
import debounce from 'lodash/debounce'
import MultipleImageUpload from '@/components/MultipleImageUpload'
import { countValidator, moneyValidator, priceValidator } from '@/utils/validate'
import ProductRowCard from '@/components/ProductRowCard.vue'


import moment from 'moment'
import BigNumber from 'bignumber.js'
import ImportErrorCard from '@/components/ImportErrorCard.vue'
import FileLink from '@/components/FileLink.vue'

export default {
  components: {
    ProductRowCard,
    MultipleImageUpload,
    UploadButton,
    ImportErrorCard,
    FileLink
  },
  data () {
    return {
      visible: false,
      dataForm: {},
      receiverList: [],
      errorList: [],
      sendType: ''//发货类型，make：成品/配件发货，purchase：物料发货
    }
  },
  computed: {
    pickerOptions(){
      return {
        disabledDate: time => { // time为形参，实参就是自动获取到的beginTime元素可以选的值
          return moment(time).isAfter(moment())
        }
      }
    },
    dialogTitle () {
      if (this.sendType === 'purchase') {
        return '物料发货'
      } else if (this.sendType === 'make') {
        return '成品/配件发货'
      }
    },
    detailRule () {
      return {
        operateTime:[{
          required: true,
          message: '请选择发货日期',
          trigger: 'change',
        }],
        count: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
          {
            validator: countValidator,
            trigger: 'change',
          },
          {
            validator: (rule, value, callback, source, options, msg) => {
              let v=new BigNumber(value)
              if (v.lte(0)) {
                callback(new Error('数量必须大于0'))
              }
              callback()
            },
            trigger: 'change',
          }
        ],
        price: [
          {
            required: false,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
          {
            validator: priceValidator,
            trigger: 'change',
          },
        ],
      }
    },
    dataRule () {
      return {
        sendDate: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'change',
        }]
      }
    }
  },
  methods: {
    //获取行中的本次发货数,返回bignumber对象
    getSendCount (row) {
      let sendCount = new BigNumber(0)
      this.receiverList.forEach(r => {
        let fs = new BigNumber(row[r.id])
        if (fs.isNaN()) {
          return
        }
        sendCount = sendCount.plus(fs)
      })
      return sendCount
    },
    priceChange (row) {
      let price = new BigNumber(row.price)
      if (price.isNaN()) {
        return
      }
      let sendCount = this.getSendCount(row)
      row.totalAmount = price.multipliedBy(sendCount).toFixed(2)
    },
    readFileSuccess (result) {
      this.errorList = result.errorList
      if (!this.$c.isArrayEmpty(result.dataList)) {
        result.dataList.forEach(item => {
          this.add2ReceiverList({ id: item.receiverId, name: item.receiverName })
          item[item.receiverId] = item.sendCount
        })
        this.dataForm.detailList = result.dataList.map(item => {
          return {
            ...item,
            sourceType: this.sendType
          }
        })
        this.receiverList.forEach(r => {
          this.dataForm.detailList.forEach(row => {
            if (!row[r.id]) {
              row[r.id] = null
            }
          })
        })
      }
    },
    add2ReceiverList (data) {
      if (this.receiverList.find(r => r.id === data.id)) {
        return
      }
      this.receiverList.push(data)
    },
    init (detailList) {
      this.errorList = []
      this.receiverList = []
      if (this.sendType === 'make') {
        this.company = { id: '', name: '' }
        this.receiverType = 'factory'
        //提取收货方清单
      }
      if (!this.$c.isArrayEmpty(detailList)) {
        //初始化收货方列表
        detailList.forEach(row => {
          this.add2ReceiverList({ id: row.receiverId, name: row.receiverName })
        })
        //初始化发货数量
        detailList.forEach(row => {
          this.receiverList.forEach(r => {
            if (this.sendType === 'make') {
              row[r.id] = 0
            } else if (this.sendType === 'purchase') {
              row[r.id] = row.sendCount
            }
            row.remark = ''
          })
        })
      }

      this.dataForm = {
        sendDate: moment().format('YYYY-MM-DD'),
        remark: '',
        imgs: '',
        detailList: detailList,
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    // 表单提交
    dataFormSubmitHandle:
        debounce(
            function () {
              this.$refs['dataForm'].validate((valid) => {
                if (!valid) {
                  return false
                }
                if (this.$c.isArrayEmpty(this.receiverList)) {
                  this.$c.error('请添加收货方')
                  return false
                }
                let postForm = []
                this.dataForm.detailList.forEach(row => {
                  this.receiverList.forEach(r => {
                    if (!row[r.id] || row[r.id] == 0) {
                      return
                    }
                    postForm.push({
                      senderId: row.senderId,
                      sourceId: row.sourceId,
                      sourceType: this.sendType,
                      productId: row.product.id,
                      sendCount: row[r.id],
                      receiverId: isNaN(parseInt(r.id.substring(0, 3))) ? '' : r.id,
                      receiverName: r.name,
                      operateTime: row.operateTime ,
                      sendRemark: row.remark,
                      price: row.price,
                      totalAmount: row.totalAmount,
                      sendImgs:this.dataForm.imgs,
                    })
                  })
                })
                this.loading = true
                this.$api2
                    .post('/trade/factorystorelog/send', postForm)
                    .then(res => {
                      this.loading = false
                      this.$c.success('保存成功').then(() => {
                        this.visible = false
                        this.$emit('change')
                      })
                    })
                    .catch((e) => {
                      this.loading = false
                    })
              })
            },
            1000,
            { leading: true, trailing: false }
        )
  },
}
</script>

<style lang="scss" scoped>
.dialog-content {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
